// extracted by mini-css-extract-plugin
module.exports = {"banner":"_3Jj4XL"};